export interface User {
  id: string;
  email: string;
  name: string;
  role: UserRole;
  can_delete_cpe: boolean;
  can_download_reports: boolean;
  must_change_password: boolean;
  last_password_change: Date;
  deleted_at: Date | null;
  created_at: Date;
  updated_at: Date;
}

export type UserRole = 'user' | 'admin' | 'super_admin';

export interface UserFormData {
  email: string;
  name: string;
  role: UserRole;
  can_delete_cpe?: boolean;
  can_download_reports?: boolean;
}

export interface UserFilters {
  search?: string;
  role?: UserRole;
  include_deleted?: boolean;
}

export interface UserPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface UserListResponse {
  success: boolean;
  data: {
    users: User[];
    pagination: UserPagination;
  };
}

export interface UserResponse {
  success: boolean;
  data: {
    user: User;
    temporaryPassword?: string;
  };
  message?: string;
}

export interface ResetPasswordResponse {
  success: boolean;
  data: {
    temporaryPassword: string;
  };
  message: string;
}

export const USER_ROLES: UserRole[] = ['user', 'admin', 'super_admin'];

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  user: 'User',
  admin: 'Admin',
  super_admin: 'Super Admin',
};

export const PAGE_SIZE_OPTIONS = [20, 50, 100];

